/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return */
/**
 * Get the object located at keypath of this object,
 * return `defaultValue` if any of the path does not exists
 *
 * @param {?Object} obj
 * @param {Array.<*>} keyPath
 * @param {*} defaultValue if not given, defaultValue is `undefined`
 * @return {*}
 */
export default function getIn(obj, keyPath, defaultValue) {
    if (Array.isArray(keyPath) && keyPath.length) {
        const key = keyPath[0];
        if (!obj || !Object.prototype.hasOwnProperty.call(obj, key)) {
            return defaultValue;
        }
        return getIn(obj[key], keyPath.slice(1), defaultValue);
    }
    return obj;
}
